import React from 'react';
import { 
  inputFill, 
  fillMaxMin, 
  vsSNPFill, 
  format, 
  formatPercent 
} from '../Helpers';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const TableHeader = ({ 
  title, 
  sectorSymbol, 
  sectorInfo, 
  updateStockInput, 
  updateDbSectorInput, 
  activePortfolioId, 
  theme, 
  hide, 
  openModal,
  openWeightModal
}) => {

  const item = sectorInfo.filter(sector => sector.symbol === sectorSymbol)[0];
  if (!item) return null;

  function onChangeInput(e, symbol) {
    updateStockInput({ 
      value: e.target.value, 
      name: e.target.name, 
      symbol: symbol,
      section: 'sectorInfo' 
    });

    updateDbSectorInput({
      value: e.target.value,
      name: e.target.name,
      symbol: symbol,
      activePortfolioId: activePortfolioId
    });
  }

  const tooltipSectorPrice = (
    <Tooltip id="tooltipIncrease">
      Price: {item.price}
    </Tooltip>
  );

  return (
    <tr className={'header-row ' + theme}>

      <td></td> 
      <td></td> 
      <td></td> 
      <td></td> 
      <td></td> 
      <td></td> 

      <td className="sector-row-heading" onClick={() => openModal(item)}>
        {title}
      </td>

      <td></td> 
      <td></td> 
      <td></td> 
      {/*<td></td> */}
      {/*<td></td> */}

      <td className={inputFill(item.resistance, item.price)}>
        <input 
          className="cell-input"
          value={item.resistance} name="resistance"
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <OverlayTrigger placement="top" overlay={tooltipSectorPrice}>
        <td className="sector-symbol">
          {item.symbol}
        </td>
      </OverlayTrigger>

      <td className={inputFill(item.price, item.support)}>
        <input 
          className="cell-input"
          value={item.support} name="support" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td>
        {formatPercent(item.scmSectorWeight)}
      </td>

      <td className={vsSNPFill(item.vsSNP)}>
        {formatPercent(item.vsSNP)}
      </td>

      <td>
        {formatPercent(item.sectorWeight)}
      </td>

      <td className={fillMaxMin(item.scmSector, 'scmSector', sectorInfo)}>
         {formatPercent(item.scmSector)}
      </td>

      <td className={fillMaxMin(item.etfTodayPercent, 'etfTodayPercent', sectorInfo)}>
        {formatPercent(item.etfTodayPercent)}
      </td>

      <td className="no-padding" style={hide()}>
        <input 
          className="cell-input"
          value={item.quarterly} name="quarterly"
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td className={fillMaxMin(item.lagLead, 'lagLead', sectorInfo)}>
        {format(item.lagLead)}
      </td>

      <td></td>
      <td style={hide()}></td>
      <td style={hide()}></td>

      <td style={hide()}>
        {format(item.quarterlyCostBasis)}
      </td>

      <td className="no-padding" style={hide()}>
        <input 
          className="cell-input" 
          value={item.adjCostbasisTotal} name="adjCostbasisTotal" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td className={fillMaxMin(item.sgPerf, 'sgPerf', sectorInfo)}>
        {formatPercent(item.sgPerf)}
      </td>

      <td className={fillMaxMin(item.etfPerf, 'etfPerf', sectorInfo)}>
        {formatPercent(item.etfPerf)}
      </td>

      <td className="no-padding" style={hide()}>
        <input 
          className="cell-input" 
          value={item.quarter1} name="quarter1" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td className="no-padding" style={hide()}>
        <input 
          className="cell-input" 
          value={item.quarter2} name="quarter2" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td className="no-padding" style={hide()}>
        <input 
          className="cell-input" 
          value={item.quarter3} name="quarter3" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td className={fillMaxMin(item.quarterLagLead, 'quarterLagLead', sectorInfo)}>
        {format(item.quarterLagLead)}
      </td>

      <td style={{ textAlign: 'center' }}>
        {item.why}
      </td>

      <td className={fillMaxMin(item.ytdTotal, 'ytdTotal', sectorInfo)}>
        {format(item.ytdTotal)}
      </td>

      <td style={hide()}></td>
      <td style={hide()}></td>

      <td className="no-padding">
        <input 
          className="cell-input" 
          value={item.deck} name="deck" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

      <td className="no-padding" style={hide()}>
        <input 
          style={{ width: 60 }}
          className="cell-input" 
          value={item.notes} name="notes" 
          onChange={(e) => onChangeInput(e, item.symbol)} />
      </td>

    </tr>
  );
}

export default TableHeader;

